<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xv695n/tc-custom/9781609250843.jpg?1705634330438" alt="This image is the cover for the book Weiser Field Guide to Ghosts, The Weiser Field Guide"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Weiser Field Guide to Ghosts, The Weiser Field Guide
      </h1>
      <p class="bookDescription body article font2">
        <b>A reference guide to the otherworld—includes illustrations.</b><br/>  <br/> From battlefield and biblical ghosts to poltergeists and orbs, <i>The Weiser Field Guide to Ghosts</i> examines categories and subcategories of ghosts across time and cultures, including commonalities and misconceptions.<br/>  <br/> Stories of encounters, legendary ghosts, and haunted places are all covered in this beautifully illustrated compendium, a veritable A-Z of the otherworld. <i>The Weiser Field Guide to Ghosts</i> is concise and comprehensive—and also includes practical tips on ghost hunting and suggested further reading.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Raymond Buckland
      </h2>
      
      <p class="authorDescription body article">Raymond Buckland's grandfather was the first of the Buckland Gypsies to give up traveling the roads in wagons and to settle into a permanent house. From his earliest years, Ray remembers listening to his father's and grandfather's tales of Romani life, and watching his grandmother read cards and tell fortunes. Ray is the author of more than fifty books on occult, magic, witchcraft, and paranormal subjects and is popularly known as "The Father of American Wicca." He lives in Ohio. Visit him on the web at: www.raybuckland.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Weiser Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?342d0e0e